// eslint-disable-next-line import/prefer-default-export
export const QUERY_VERSION = new URLSearchParams(window.location.search).get('version') ?? '2.0.0';

export const IS_T3_WEBSITE = new URLSearchParams(window.location.search).has('isdealer');
